import { render, staticRenderFns } from "./PersonalInfoBlock.vue?vue&type=template&id=3b543618&scoped=true"
import script from "./PersonalInfoBlock.vue?vue&type=script&lang=js"
export * from "./PersonalInfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b543618",
  null
  
)

export default component.exports